<template>
  <div v-show="hasProducts" class="content-actions comment-options">
    <icon-button
      type="button"
      class="-ico-only -no-container -menu-opener"
      icon="loyalty"
      :label="isMenuOpen ? 'Pay it Forward Menu Expanded' : 'Pay it Forward Menu Collapsed'"
      :aria-expanded="isMenuOpen ? 'true' : 'false'"
      :aria-controls="menuId"
      @click-action="handleMenuOpen"
    />
    <outside-click :disabled="!isMenuOpen" @outside-click-action="handleMenuClose">
      <div
        :id="menuId"
        class="content-actions-group"
        :class="{ '-open': isMenuOpen }"
        :inert="!isMenuOpen"
      >
        <div class="content-actions-close">
          <icon-button
            type="button"
            class="-ico-only -no-container"
            icon="close"
            label="Close Menu"
            @click-action="handleMenuClose"
          />
        </div>
        <ul class="content-actions-list">
          <li
            v-for="product in shopStore.payForwardProducts"
            :key="product.id"
            class="content-action"
          >
            <add-to-cart-button
              item-type="product"
              :item-id="product.id"
              :gift-user-id="giftUserId"
              :button-label="product.title"
              button-classes="-ico-txt -no-hover -no-case -menu-add-to-cart"
              :server-redirect-to-cart="false"
            />
          </li>
          <li class="content-action">
            <a
              class="btn -material -ico-txt -no-hover -no-case -menu-add-to-cart"
              href="/store/pay-it-forward"
            >
              <i class="material-symbols-outlined btn-ico" aria-hidden="true">help_center</i>
              <span class="btn-txt">How it Works</span>
            </a>
          </li>
        </ul>
      </div>
    </outside-click>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue'
import { useShopStore } from '@/stores/shop.ts'
import OutsideClick from '@/components/tool-tips/outside-click.vue'
import IconButton from '@/components/buttons/icon-button.vue'
import AddToCartButton from '@/components/cart/add-to-cart-button.vue'

/** PROPS */
const props = withDefaults(
  defineProps<{
    entityType: string
    entityId: number
    giftUserId: number
    initProducts?: boolean
  }>(),
  {
    initProducts: false,
  },
)

/** STATE */
const isMenuOpen = ref(false)
const shopStore = useShopStore()

/** LIFECYCLE */
onBeforeMount(() => {
  if (props.initProducts) {
    shopStore.initPayForwardProducts()
  }
})

/** COMPUTED */
const menuId = computed(() => `pay-forward-actions-menu-${props.entityId}-${props.giftUserId}`)

const hasProducts = computed(() => {
  return shopStore.payForwardProducts.length > 0
})

/** METHODS */
function handleMenuOpen() {
  isMenuOpen.value = true
}

function handleMenuClose() {
  isMenuOpen.value = false
}
</script>
